/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { IoOpenOutline } from '@react-icons/all-files/io5/IoOpenOutline';
import { formatDate } from '~helpers/date-time';

import useTranslate from '~hooks/useTranslate/useTranslate';
import Collapse from '~atoms/collapse';
import Author from 'gatsby-matrix-theme/src/components/atoms/author/template-three';
import ContributorsIcon from 'gatsby-matrix-theme/src/images/icons/contributors';
import FactCheckIcon from '~images/icons/fact-check';
import Clock from '~images/icons/clock';
import styles from './review-credits.module.scss';

const ReviewCredits = ({
  authors,
  authorImageWidth = 48,
  authorImageHeight = 48,
  clock = <Clock />,
  date,
  dateFormat = 'DD.MM.YYYY',
  editorialIcon = <IoOpenOutline size={18} />,
  editorialContent = (
    <div className={styles.content}>
      According to our <a href="/">Editorial Guide</a>
    </div>
  ),
  hasAuthorBox = false,
  initOpen = false,
  onlyMobile = true,
  onlyDesktop = true,
  prefix = '',
  readingTime,
  reviewer,
  showEditorialGuide = false,
  showPrefix = true,
  showReadingTimeText = true,
  showAuthorTitle = true,
  showReviewerTitle = true,
  showVerification = true,
  splitDateFormat = '.',
  type = 'default',
  verifyIcon = <FactCheckIcon width={15} height={15} />,
}) => {
  const getPrefixBasedOnPage = type.includes('review')
    ? useTranslate('reviewed_by_page', 'This page is reviewed by')
    : useTranslate('written_by_page', 'This page is written by');
  const formatedDate = date && formatDate(date, dateFormat, splitDateFormat, 'en-GB');

  const {
    name: reviewerName,
    author_title: reviewerTitle,
    image: reviewerImg,
    profile_page_path: reviewerLink,
  } = reviewer || {};

  const contentText = (
    <div className={styles.reviewCredits || ''}>
      {(authors?.length || reviewer) && (
        <div className={styles.people || ''}>
          {authors &&
            authors?.map((author) => {
              const {
                name: authorName,
                author_title: authorTitle,
                image: authorImg,
                profile_page_path: authorLink,
              } = author || {};

              return (
                <Author
                  authorImage={authorImg}
                  authorImageHeight={authorImageHeight}
                  authorImageWidth={authorImageWidth}
                  authorName={authorName}
                  authorPath={authorLink}
                  authorTitle={authorTitle}
                  prefix={useTranslate(prefix, prefix) || getPrefixBasedOnPage}
                  customStyles={`${styles.authorCommon || ''} ${styles.author || ''}`}
                  showPrefix={false}
                  showTitle={showAuthorTitle}
                  verify={verifyIcon}
                  type={type}
                />
              );
            })}
          {reviewer && (
            <Author
              authorImage={reviewerImg}
              authorImageHeight={authorImageHeight}
              authorImageWidth={authorImageWidth}
              authorName={reviewerName}
              authorPath={reviewerLink}
              authorTitle={reviewerTitle}
              isReviewer
              prefix={prefix}
              customStyles={`${styles.authorCommon || ''} ${styles.reviewer || ''}`}
              showPrefix={showPrefix}
              showTitle={showReviewerTitle}
              showVerification={showVerification}
              type={type}
            />
          )}
        </div>
      )}
      {(readingTime || date) && (
        <div className={styles.readtimeDate || ''}>
          {readingTime && (
            <div className={styles.readingWithBorder || ''}>
              <img width={14} height={14} className={styles.clock || ''} src={clock} alt="clock" />
              {showReadingTimeText && (
                <span className={styles.readingTimeText}>
                  {useTranslate('reading_time', 'Reading time')}
                </span>
              )}
              {` ${readingTime} ${useTranslate('minutes', 'min')}`}
              {!showReadingTimeText && (
                <span className={styles.readText || ''}>{useTranslate('read', 'read')}</span>
              )}
            </div>
          )}
          {date && (
            <div className={styles.dateTimeWrapper || ''}>
              <span>{useTranslate('published_on', 'Published on')}</span>
              {` `}
              {hasAuthorBox ? (
                <a href="#authorbox" className={styles.dateLink || ''}>
                  {formatedDate}
                </a>
              ) : (
                <span className={styles.noLink || ''}>{formatedDate}</span>
              )}
            </div>
          )}
        </div>
      )}
      {showEditorialGuide && (
        <div className={styles.editorial || ''}>
          {editorialContent}
          {editorialIcon}
        </div>
      )}
    </div>
  );

  const buttonText = (
    <>
      <ContributorsIcon />
      {useTranslate('contributors', 'About this page')}
    </>
  );

  return (
    <div className={styles.authorWraper || ''}>
      <Collapse
        onlyMobile={onlyMobile}
        onlyDesktop={onlyDesktop}
        buttonText={buttonText}
        contentText={contentText}
        initOpen={initOpen}
      />
    </div>
  );
};

export default ReviewCredits;
